import React from 'react'
import { Link } from 'react-router-dom'

export default function LogisticsInvest() {
  return (
    <>
      <section className="logistics-invest">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-5">
              <div className="logistics-content">
                <span className="gradient-color">OEM Vs. Aftermarket</span>
                <h3 className="heading">Genuine Equipment  Cost Less Over Time</h3>
                <p>An aftermarket equipment  that saves money today can cost significantly more within months through accelerated wear, repeat failures, and warranty complications. Genuine components are built to the exact tolerances your machine was designed around, which means they fit correctly, perform consistently, and do not create new problems while solving the original one.</p>
                <Link className="default-btn" to="/contact"> <span>Get Expert Advice</span></Link>
              </div>
            </div>
            <div className="col-md-12 col-lg-7">
              <div className="logistics-wrapper">
                <div className="row">
                  <div className="col-md-6 col-lg-6">
                    <div className="logistics-text">
                      <div className="icon-wrap">
                        <img src="/assets/images/exact-image1.webp" alt="Exact" className="img-responsive" />
                      </div>
                      <label className="heading">Exact Specifications</label>
                      <p>Built to the precise dimensions and tolerances of your machine model so there is no stress on surrounding components during operation.</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="logistics-text">
                      <div className="icon-wrap">
                        <img src="/assets/images/exact-image2.webp" alt="Exact" className="img-responsive" />
                      </div>
                      <label className="heading">Warranty Stays Intact</label>
                      <p>Genuine equipment  keep your warranty valid, while substitutes can void coverage and leave you unprotected.</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="logistics-text">
                      <div className="icon-wrap">
                        <img src="/assets/images/exact-image3.webp" alt="Exact" className="img-responsive" />
                      </div>
                      <label className="heading">Longer  Life</label>
                      <p>Engineered equipment  last longer than generic ones, reducing repairs and improving overall performance and reliability.</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="logistics-text">
                      <div className="icon-wrap">
                        <img src="/assets/images/exact-image4.webp" alt="Exact" className="img-responsive" />
                      </div>
                      <label className="heading">No  Damage</label>
                      <p>ILL Fitting equipment  strain bearings, seals, and motors. Genuine components remove that risk and protect the machine.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
